var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9713 22.896V20.144C11.9713 19.4416 12.545 18.8721 13.2526 18.8721H15.8393C16.1792 18.8721 16.5051 19.0061 16.7454 19.2446C16.9856 19.4832 17.1206 19.8067 17.1206 20.144V22.896C17.1185 23.1881 17.2339 23.4689 17.4411 23.6762C17.6484 23.8834 17.9304 24 18.2246 24H19.9894C20.8137 24.0021 21.6049 23.6785 22.1885 23.1007C22.772 22.5229 23.1 21.7383 23.1 20.92V13.0802C23.1 12.4192 22.8049 11.7923 22.2942 11.3682L16.2906 6.60828C15.2463 5.77371 13.75 5.80065 12.7369 6.67228L6.87031 11.3682C6.33547 11.7798 6.0158 12.4086 6 13.0802V20.912C6 22.6175 7.39264 24 9.11056 24H10.8351C11.4461 24 11.9427 23.5106 11.9471 22.904L11.9713 22.896Z",
    fill: "#121111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocial);
export default __webpack_public_path__ + "static/media/icon_social.93e0b6b6e014e2bc538d0a2e90b25f1a.svg";
export { ForwardRef as ReactComponent };